import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersListPageComponent } from './pages/user/users-list-page/users-list-page.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { CerListPageComponent } from './pages/cer/cer-list-page/cer-list-page.component';
import { SiteListPageComponent } from './pages/site/site-list-page/site-list-page.component';
import { CerAddPageComponent } from './pages/cer/cer-add-page/cer-add-page.component';
import { CerEditPageComponent } from './pages/cer/cer-edit-page/cer-edit-page.component';
import { UserAddPageComponent } from './pages/user/user-add-page/user-add-page.component';
import { UserEditPageComponent } from './pages/user/user-edit-page/user-edit-page.component';
import { SiteAddPageComponent } from './pages/site/site-add-page/site-add-page.component';
import { SiteEditPageComponent } from './pages/site/site-edit-page/site-edit-page.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Amministrazione',
    },
    children: [
      {
        path: 'users',
        component: UsersListPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRole.ADMIN],
          },
          title: 'Gestione utenti',
          urls: [
            { title: 'Amministrazione', url: '/administration/users' },
            { title: 'Gestione utenti' },
          ],
        },
      },
      {
        path: 'users/add',
        component: UserAddPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRole.ADMIN],
          },
          title: 'Aggiungi utente',
          urls: [
            { title: 'Amministrazione', url: '/administration/users' },
            { title: 'Aggiungi utente' },
          ],
        },
      },
      {
        path: 'users/:id',
        component: UserEditPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRole.ADMIN],
          },
          title: 'Modifica utente',
          urls: [
            { title: 'Amministrazione', url: '/administration/users' },
            { title: 'Modifica utente' },
          ],
        },
      },
      {
        path: 'cer',
        component: CerListPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Gestione CER',
          urls: [
            { title: 'Amministrazione', url: '/administration/cer' },
            { title: 'Gestione CER' },
          ],
        },
      },
      {
        path: 'cer/add',
        component: CerAddPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Inserisci CER',
          urls: [
            { title: 'Amministrazione', url: '/administration/cer' },
            { title: 'Inserisci CER' },
          ],
        },
      },
      {
        path: 'cer/:id',
        component: CerEditPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Modifica CER',
          urls: [
            { title: 'Amministrazione', url: '/administration/cer' },
            { title: 'Modifica CER' },
          ],
        },
      },
      {
        path: 'sites',
        component: SiteListPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Lista siti',
          urls: [
            { title: 'Amministrazione', url: '/administration/sites' },
            { title: 'Gestione siti' },
          ],
        },
      },
      {
        path: 'site/add',
        canActivate: [ngxPermissionsGuard],
        component: SiteAddPageComponent,
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Aggiungi sito',
          urls: [
            { title: 'Gestione siti', url: '/administration/sites' },
            { title: 'Aggiungi sito' },
          ],
        },
      },
      {
        path: 'site/:id',
        canActivate: [ngxPermissionsGuard],
        component: SiteEditPageComponent,
        data: {
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
          title: 'Modifica sito',
          urls: [
            { title: 'Gestione siti', url: '/administration/sites' },
            { title: 'Modifica sito' },
          ],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdministrationRoutingModule {}
